// extracted by mini-css-extract-plugin
module.exports = {"sticky":"sticky_sticky__ijZEX","hasShadow":"sticky_hasShadow__5duxm","topShadow":"sticky_topShadow__uSPN9","bottomShadow":"sticky_bottomShadow__VZHpf"};